/**
 * Notifications Widget Exports
 *
 * Main exports for the notification bell widget
 */

export { NotificationBell } from './NotificationBell';
export type { NotificationItem, NotificationType, NotificationPriority } from './types';
